import { api } from ".";

const basePath = "/skill";

export const createSkill = async ({
  name,
  description,
}: any) => {
  try {
    const res = await api.post(`${basePath}`, {
      name,
      description,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const updateSkillById = async ({ id, updates }: any) => {
  try {
    const res = await api.put(`${basePath}`, {
      _id: id,
      ...updates,
    });
    return res;
  } catch (error) {
    console.error("Error updating user:", error);
    return error;
  }
};

export const getSkillList = async (params: Record<string, any> = {}) => {
  try {
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined)
    );
    const res = await api.get(`${basePath}/list`, { params: filteredParams });
    return res;
  } catch (error) {
    return error;
  }
};

export const deleteSkill = async ({ id }: { id: string }) => {
  try {
    const res = await api.delete(`${basePath}`, {
      data: { _id: id },
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const getSkillSelectData = async () => {
  try {
    const res = await api.get(`${basePath}/select-data`);
    return res;
  } catch (error) {
    return error;
  }
};
